<p-toast
  class="app-toast"
  position="top-right"
  [life]="5000"
>
  <ng-template
    #message
    let-message
  >
    <div class="app-toast__content">
      <svg
        class="app-toast__icon"
        [appIcon]="`${message.severity}-circle`"
      />

      <div class="app-toast__text-group">
        <p class="app-toast__summary">{{ message.summary }}</p>

        @if (message.detail) {
          <p class="app-toast__detail">{{ message.detail }}</p>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
